//Componentes generales
import { useEffect, useContext } from "react";
import SoliList from "../../components/SoliList/SoliList";
import { STATES_SOLICITUD } from "../../utils/states";

//Estilos
import "./Solicitudes.css";

//Contexto
import solicitudesGLBContext from "../../context/solicitudesGLB/solicitudesGLBContext";
import solicitudesContext from "../../context/solicitudes/solicitudesContext";
import authContext from "../../context/authentication/authContex";
import agregarSoliAjusContext from "../../context/agregarSoliAjus/agregarSoliAjusContext";
import proveedoresContext from "../../context/proveedores/proveedoresContext";

import clienteAxios from "../../config/axios";

// Alertas
import Swal from "sweetalert2";
import { useState } from "react";

function Solicitudes(props) {
  //Context auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context solicitudes
  const sContext = useContext(solicitudesContext);
  const {
    solicitudes,
    filtrosRango,
    filtrosEstado,
    modificarFiltrosEstado,
    modificarFiltrosRango,
    filtrar,
  } = sContext;

  //Contexto general solicitudes
  const gSContext = useContext(solicitudesGLBContext);
  const { modificarEstado, getFilesBySolicitud } = gSContext;

  //Context Edit Solicitud
  const addSoliContext = useContext(agregarSoliAjusContext);
  const { guardarSolicitudAjuste, editarSolicitudAjusteBE } = addSoliContext;

  //Context proveedores
  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;

  const [listSolicitudesHome, setListSolicitudesHome] = useState(
    solicitudes ? solicitudes : []
  );

  /* 
        Disparador que actualiza la lista de proveedores disponibles al momento de renderizar el componente.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarProveedores();
    };
    fn();
  }, []);

  useEffect(() => {
    if (solicitudes)
      setListSolicitudesHome(filtrar(solicitudes, filtrosEstado));
  }, [solicitudes, filtrosEstado, filtrosRango]);

  const handleCheckPermisos = (roles_autorizados) => {
    let autoriza = false;
    for (const element of roles_autorizados) {
      if (usuario.userType.some((item) => item.typeName === element)) {
        autoriza = true;
      }
    }
    return autoriza;
  };

  /* 
        Manejador para la modificación rapida de una solicitud. Se utiliza en 3 ocaciones, edición del estado, notas privadas y notas publicas.
            Donde solicitud es la solicitud a actualizar.
                  upd es lo modificado.
    */
  const handleModifyStateSolicitud = async (solicitud, upd) => {
    const resp = await modificarEstado(solicitud, usuario, upd);
    return resp;
  };

  /* 
        Manejador que recupera los archivos adjuntados a una solicitud especificado por parametro.
            Donde solicitud es la solicitud de donde recuperar los archivos.
    */
  const handlerRecuperaFiles = async (solicitud) => {
    const files = await getFilesBySolicitud(solicitud);
    return files
      ? files.map((f) => {
          return {
            name: f.fileName === undefined ? f.name : f.fileName,
            url: f.url,
          };
        })
      : [];
  };

  const apFiltros = async (filtrosProp) => {
    modificarFiltrosEstado(filtrosProp.filterEstado);
    await modificarFiltrosRango(usuario.nroCta, filtrosProp.filterRango);
  };

  /* 
        Función encargada de validar los campos de la solicitud a guardar.
        Se llama al momento de guardar.
    */
  const validacionesCampos = (solicitud, files) => {
    let resp = "";
    if (solicitud.notePubl === "" && files.length == 0) {
      resp = "Ingrese los ajustes a realizar.";
    }
    return resp;
  };

  /* 
        Manejador que controla el evento ante un click en el boton editar, recuperando los archivos adjuntos para comenzar la edición.
            Donde solicitud es la solicitud a editar. 
    */
  const handdleEditClick = async (solicitud) => {
    try {
      const files = (await getFilesBySolicitud(solicitud)).map((s) => {
        return {
          name: s.fileName === undefined ? s.name : s.fileName,
          url: s.url,
        };
      });
      return { files };
    } catch (error) {
      console.log("error");
      return null;
    }
  };

  /* 
        Manejador encargado de guardar los cambios realizados en la edición de una solicitud. Realiza validaciones y si no la supera no se guarda las modificaciones de la solicitud.  
            Donde solicitud es la solicitud a guardar.
                  files son los archivos adjuntos de la solicitud.
    */
  const handdleEdit = async (solicitud, files) => {
    const msj = validacionesCampos(solicitud, files);

    if (solicitud !== undefined && solicitud !== null) {
    if (msj === "") {
        const resp = await editarSolicitudAjusteBE(
          solicitud,
          files,
          usuario
        );
        Swal.fire({
          title: `Se modificó la ${resp.soliAjusCodFor} - ${resp.soliAjusNroFor}`,
          icon: "success",
          text: `Puede hacer el seguimiento de su solicitud accediendo al panel de solicitudes desde la barra inferior de Navegación.`,
          showConfirmButton: true,
          allowEnterKey: true,
        });
    } else {
      Swal.fire({
        title: msj,
        icon: "warning",
        showConfirmButton: true,
        allowEnterKey: true,
      });
    }
  }
  };

  return (
    <div className="container-test">
      <SoliList
        proveedores={proveedores}
        solicitudes={listSolicitudesHome}
        modificarEstado={handleModifyStateSolicitud}
        recuperaFilesDetalle={handlerRecuperaFiles}
        filtros={{ filtrosRango, filtrosEstado }}
        aplicarFiltros={apFiltros}
        checkPermisos={handleCheckPermisos}
        eventoClickEdicion={handdleEditClick}
        editar={handdleEdit}
      />
    </div>
  );
}

export default Solicitudes;